// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__zp2wo","ldsDualRing":"LoadingScreen_ldsDualRing__G1ROg","lds-dual-ring":"LoadingScreen_lds-dual-ring__MPOAM"};